import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { ClientProvider } from '../providers/client.provider';
import { FullClientInterface, IdInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetClientUseCaseParams {
    code: IdInterface;
}

@Injectable()
export class GetClientUseCase implements UseCaseWithParam<GetClientUseCaseParams, Observable<Transaction<FullClientInterface>>> {
    constructor(private contractProvider: ContractProvider, private clientProvider: ClientProvider) {}

    bind(params: GetClientUseCaseParams): Observable<Transaction<FullClientInterface>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) =>
                        this.clientProvider.find(params.code, contract).pipe(
                            map((transactionClient) =>
                                transactionClient.map(
                                    (client) => Transaction.success(cloneDeep(client)),
                                    (throwable) => Transaction.error(throwable.message)
                                )
                            )
                        ),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
